import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=56ba9359&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=56ba9359&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba9359",
  null
  
)

export default component.exports